/* -----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/
/**
 * @packageDocumentation
 * @module shared-models
 */
/**
 * @deprecated This package will be removed in JupyterLab 4. Please use @jupyter/ydoc directly
 */
export * from '@jupyter/ydoc';
//# sourceMappingURL=index.js.map